import React from 'react';

// The Status chips above an engagement list. The Grouped board (Management and
// My Records alike) and My Records' List view all render this one row, so the
// same four statuses are offered, look the same and behave the same wherever
// an engagement list is filtered.
//
// Multi-select, and nothing ticked is a legitimate state: it means no status
// filter at all. The row says so — a filter bar with every chip off and an
// empty table underneath reads like data loss.
const EngagementStatusFilter = ({ options = [], active = [], onToggle }) => (
  <>
    <span className="text-xs font-semibold text-slate-500 uppercase mr-1">Status</span>
    {options.map((s) => {
      const on = active.includes(s);
      return (
        <button
          key={s}
          type="button"
          onClick={() => onToggle(s)}
          className={`px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${
            on
              ? 'bg-blue-50 border-blue-200 text-blue-700'
              : 'bg-white border-slate-200 text-slate-500 hover:bg-slate-50'
          }`}
        >
          {s}
        </button>
      );
    })}
    {active.length === 0 && <span className="text-xs text-slate-500">nothing selected — showing all</span>}
  </>
);

export default EngagementStatusFilter;
